import React from 'react';
import ReactMarkdown from 'react-markdown';

const Markdown = ({ source, className }) => (
  <ReactMarkdown source={source} className={className} unwrapDisallowed disallowedTypes={['paragraph']} />
);

export default Markdown;
